import React from "react";

import { styled } from "@mui/material";
import MuiAccordion, {
	AccordionProps,
	accordionClasses,
} from "@mui/material/Accordion";
import MuiAccordionSummary, {
	AccordionSummaryProps,
	accordionSummaryClasses,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";

import { Iconify } from "@onair/minimal-ui/iconify";

const Accordion = styled((props: AccordionProps) => (
	<MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
	"&:not(:last-child)": {
		borderBottom: 0,
	},
	"&::before": {
		display: "none",
	},
	[`&.${accordionClasses.root}`]: {
		marginBottom: "0 !important",
		border: "none",
		boxShadow: "none",
	},
}));

const AccordionSummary = styled(
	({
		onToggleExpand,
		...props
	}: AccordionSummaryProps & { onToggleExpand: () => void }) => (
		<MuiAccordionSummary
			expandIcon={
				<Iconify
					icon="eva:arrow-ios-downward-outline"
					onClick={onToggleExpand}
				/>
			}
			{...props}
		/>
	),
)(({ theme }) => ({
	backgroundColor: "white",
	[`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
		{
			transform: "rotate(180deg)",
		},
	[`& .${accordionSummaryClasses.content}`]: {
		margin: "0 !important",
		marginTop: "0 !important",
		marginBottom: "0 !important",
	},
	[`&.${accordionSummaryClasses.root}`]: {
		gap: "12px !important",
		padding: "24px",

		[`@media(max-width: 1024px)`]: {
			padding: "16px",
		},
	},
	...theme.applyStyles("dark", {
		backgroundColor: "rgba(255, 255, 255, .05)",
	}),
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: "0 24px 24px",
	[`@media(max-width: 1024px)`]: {
		padding: "0 16px 16px",
	},
}));

export { AccordionSummary, AccordionDetails, Accordion };
